// react-router looks for a url like 'album/:id' but our files are named like 'album/[id].js'
// so here we replace colon (:) and add brackets instead.
// "hello/:firstId/world/:socond/:third.js" -> "hello/[firstId]/world/[socond]/[third].js"
export const getFilePathForRouter = (path) => {
  return path.replace(/(:\w+)/g, (matched) => matched.replace(':', '[') + ']');
};
